import React from 'react';
import { Form, Input } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const Number = ({
    value = '',
    name,
    onChange,
    isDisabled,
    hintKey,
    noLabel,
    className,
    text,
    error,
    placeholder,
    isRequired,
    isInteger,
    autoFocus,
    isGrid,
    size,
    numberPoint
}) => {
    const { t } = useTranslation();

    value = value ?? '';

    const handleOnChange = (e, { value }) => {
        if (isInteger) {
            onChange(e, {
                name,
                value: value.toString().replace(/[^\d-]/g, '').substring(0, 9),
            });
        }

        if (!isInteger) {
            onChange(e, {
                name,
                value: (numberPoint ? value.toString().replace(/[^\d.]/g, '') : value.toString()).substring(0, 12),
            });
        }
    };

    return (
        <Form.Field>
            {!noLabel ? (
                <label className={isDisabled ? 'label-disabled' : null}>
                    <span dangerouslySetInnerHTML={{ __html: `${t(text || name)}${isRequired ? ' *' : ''}` }} />
                </label>
            ) : null}
            <Input
                placeholder={t(placeholder)}
                className={className}
                type={isInteger||numberPoint ? 'text' : 'number'}
                error={error}
                disabled={isDisabled || false}
                name={name}
                value={value}
                step="any"
                transparent={isGrid}
                autoFocus={autoFocus}
                onChange={handleOnChange}
                autoComplete="off"
                size={size}
            />
            {hintKey ? (
                <span className="label-hint">{t(hintKey)}</span>
            ) : null}
            {hintKey && error && typeof error === 'string' && <br/>}
            {error && typeof error === 'string' ? (
                <span className="label-error">{error}</span>
            ) : null}
        </Form.Field>
    );
};
export default Number;
